import { Component, Input, Output, EventEmitter, forwardRef, ElementRef, OnInit, HostListener, SimpleChanges, OnChanges, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormGroup } from '@angular/forms';

@Component({
    standalone: false,
    selector: 'res-custom-slider',
    templateUrl: './custom-slider.component.html',
    styleUrls: ['./custom-slider.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CustomSliderComponent),
            multi: true
        }
    ]
})

export class CustomSliderComponent implements ControlValueAccessor {
    sliderId = '_' + window.crypto.getRandomValues(new Uint32Array(1))[0].toString(36);

    @Input() content: string;
    @Input() allowEditInput: boolean;
    @Input() min: number;
    @Input() max: number;
    @Input() _selectedValue: number;
    @Input() _selectedEditValue: any;
    @Input()
    get selectedValue() {
        return Math.trunc(this._selectedValue);
    }
    @Output() selectedValueChange = new EventEmitter();
    set selectedValue(val) {
        this._selectedValue = val;
        this._selectedEditValue = val;
        this.selectedValueChange.emit(this._selectedValue);
    }
    get selectedEditValue() {
        return Math.trunc(this._selectedEditValue);
    }
    set selectedEditValue(val) {
        if (val === null) {
            this._selectedEditValue = undefined;
        } else {
            this._selectedEditValue = val;
        }
    }
    @Input() step: number;
    @Input() isDisabled: boolean;
    @Input() hidePlusMinus: boolean;
    @Input() automationId: string;
    @Input() inputWidth: number;
    @Input() onSelectionChanged: (selectedValue: number) => void;
    @Input() middleRowTemplate: TemplateRef<any>;
    public contentForm: UntypedFormGroup;

    private propagateChange = (_: any) => {
        return;
    };

    writeValue(selectedValue: number): void {
        this.selectedValue = selectedValue;
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        return;
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    constructor(public changeDetector: ChangeDetectorRef) {
    }

    onChange(): void {
        this.propagateChange(this.selectedValue);
    }

    onEdit(): void {
        setTimeout(() => {
            if (this.selectedEditValue > this.max) {
                this.selectedEditValue = this.max;
            } else if (!this.selectedEditValue || this.selectedEditValue < this.min) {
                this.selectedEditValue = this.min;
            }
            this.selectedValue = this.selectedEditValue;
        }, 500);
    }
}
